import styles from "@/components/about-popup.module.css";
import PopupShell from "@/components/popup-shell";
import globals from "@/globals";
import * as signals from "@/signals";
import { closePopup, getSupportLink } from "@/utils";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DialogTitle } from "@headlessui/react";
import clsx from "clsx";
import i18next, { t } from "i18next";
import { JSX } from "react";

function AboutPopup(): JSX.Element {
	const closeAboutPopup = (): void => {
		signals.isClosingDialog.value = true;
		window.setTimeout(() => {
			signals.isClosingDialog.value = false;
			closePopup("about");
		}, globals.ANIMATION_WAIT_TIME);
	};

	return (
		<PopupShell
			className={clsx(styles["container"], "msg-box")}
			isClosing={signals.isClosingDialog.value}
			isOpen
			onClose={closeAboutPopup}
		>
			<div className={clsx("app-icon", styles["app-icon"])}></div>
			<DialogTitle
				as="h1"
				className={styles["app-name"]}
			>
				{t("rthWebHosting")}
			</DialogTitle>
			<div className={styles["info-container"]}>
				<div>
					&copy; 2018-{new Date().getFullYear()}&nbsp;
					<a
						className="link"
						href={
							i18next.language.startsWith("zh")
								? "https://www.retiehe.com/"
								: "https://www.retinbox.com/"
						}
						rel="noreferrer"
						target="_blank"
					>
						{t("fuzhouRetieheSoftwareCoLtd")}
					</a>
				</div>
				<div className={styles["links-container"]}>
					<a
						className={styles["about-link"]}
						href="https://docs.retiehe.com/tos.html"
						rel="noreferrer"
						target="_blank"
					>
						{t("termsOfService")}
						<FontAwesomeIcon icon={faChevronRight} />
					</a>
					<a
						className={styles["about-link"]}
						href="https://docs.retiehe.com/privacy.html"
						rel="noreferrer"
						target="_blank"
					>
						{t("privacyPolicy")}
						<FontAwesomeIcon icon={faChevronRight} />
					</a>
					<a
						className={styles["about-link"]}
						href={getSupportLink()}
						rel="noreferrer"
						target="_blank"
					>
						{t("helpAndFeedback")}
						<FontAwesomeIcon icon={faChevronRight} />
					</a>
				</div>
			</div>
			<div className="button-container">
				<button
					className="default-button"
					onClick={closeAboutPopup}
					type="button"
				>
					{t("ok")}
				</button>
			</div>
		</PopupShell>
	);
}

export default AboutPopup;
